define("ExternalVendor.Inventory.CheckoutEntryPoint", [
  "LiveOrder.Model",
  "Profile.Model",
  "SDB.SDBLocations.Model",
  "ExternalVendor.Inventory.SS2Model",
  "external_vendor_inventory_module.tpl",
  "OrderWizard.Module.CartSummary",
  "Header.MiniCart.View",
  "OrderWizard.Step",
], function (
  LiveOrderModel,
  ProfileModel,
  SDBLocationsModel,
  ExternalVendorInventorySS2Model,
  external_vendor_inventory_module_tpl,
  CartSummary,
  HeaderMiniCart,
  OrderWizardStep
) {
  "use strict";
  return {
    mountToApp: function mountToApp(container) {
      /** @type {CheckoutComponent} */
      var Checkout = container.getComponent("Checkout");
      /** @type {LiveOrder.Model} */
      var LiveOrder = LiveOrderModel.getInstance();
      /** @type {Profile.Model} */
      var Profile = ProfileModel.getInstance();

      var env = container.getComponent("Environment");

      var LocationsModel = SDBLocationsModel.getInstance();
      var Model = ExternalVendorInventorySS2Model.getInstance();
      var recordTypesWithInventory = Model.recordTypesWithInventory;

      var getInventoryJson = function getInventoryJson() {
        var extInventoryJson = localStorage.getItem(
          "custbody_sdb_store_ext_inv_data"
        );
        if (typeof extInventoryJson === "string") {
          extInventoryJson = JSON.parse(extInventoryJson);
        } else if (!extInventoryJson) {
          extInventoryJson = {};
        }
        return extInventoryJson;
      };
      var getInternalJson = function getInternalJson() {
        var intInventoryJson = localStorage.getItem(
          "custbody_sdb_store_int_inv_data"
        );
        if (typeof intInventoryJson === "string") {
          intInventoryJson = JSON.parse(intInventoryJson);
        } else if (!intInventoryJson) {
          intInventoryJson = {};
        }
        return intInventoryJson;
      };

      var setInventoryJson = function setInventoryJson(data) {
        var inventoryJson =
          typeof data === "string" ? data : JSON.stringify(data);
        localStorage.setItem("custbody_sdb_store_ext_inv_data", inventoryJson);
      };
      var setInternalJson = function setInternalJson(data) {
        var inventoryJson =
          typeof data === "string" ? data : JSON.stringify(data);
        localStorage.setItem("custbody_sdb_store_int_inv_data", inventoryJson);
      };

      var setExternalInventory = function setExternalInventory() {
        var isLoggedIn = Profile.get("isLoggedIn");
        if (isLoggedIn === "T") {
          var extInventoryJson = getInventoryJson();
          var shoppingExperience =
            LocationsModel.getShoppingExperience() == "online";

          var lines = LiveOrder.get("lines").models;
          lines.forEach(function (line) {
            var id = line.get("item").id;
            if (extInventoryJson[id] && extInventoryJson[id][0]) {
              extInventoryJson[id][0].itemData.isOnline =
                shoppingExperience || false;
            } else {
              extInventoryJson[id] = [
                { itemData: { isOnline: shoppingExperience || false } },
              ];
            }
          });

          var extInventoryString = JSON.stringify(extInventoryJson);
          var options = LiveOrder.get("options");
          LocationsModel.set(
            "custbody_sdb_store_ext_inv_data",
            extInventoryString
          );
          options.custbody_sdb_store_ext_inv_data = extInventoryString;
        }
      };
      var setInternalInventory = function setInternalInventory() {
        var isLoggedIn = Profile.get("isLoggedIn");
        if (isLoggedIn === "T") {
          var intInventoryJson = getInternalJson();
          var shoppingExperience =
            LocationsModel.getShoppingExperience() == "online";

          var lines = LiveOrder.get("lines").models;
          lines.forEach(function (line) {
            var id = line.get("item").id;
            if (intInventoryJson[id] && intInventoryJson[id][0]) {
              intInventoryJson[id][0].itemData.isOnline =
                shoppingExperience || false;
            } else {
              intInventoryJson[id] = [
                { itemData: { isOnline: shoppingExperience || false } },
              ];
            }
          });

          var intInventoryString = JSON.stringify(intInventoryJson);
          var options = LiveOrder.get("options");
          LocationsModel.set(
            "custbody_sdb_store_int_inv_data",
            intInventoryString
          );
          options.custbody_sdb_store_int_inv_data = intInventoryString;
        }
      };
      if (Checkout) {
        Checkout.on("afterShowContent", function () {
          var delivery = document.querySelector(
            '[data-action="select-delivery-option-radio"]'
          );
          if (delivery) delivery.click();
          Model.getExternalInventory(updateAllLinesModel()).then(function () {
            updateExternalInventory();
          });
          LocationsModel.on({
            "change:location": function changeLocation() {
              if (LocationsModel.getShoppingExperience() == "instore") {
                Model.getExternalInventory(updateAllLinesModel()).then(
                  function () {
                    updateExternalInventory();
                  }
                );
              }
            },
            "change:shoppingExperience": function changeShoppingExperience() {
              if (LocationsModel.getShoppingExperience() == "online") {
                Model.getExternalInventory(updateAllLinesModel()).then(
                  function () {
                    updateExternalInventory();
                  }
                );
              }
            },
          });
        });

        CartSummary.prototype.getContext = _.wrap(
          CartSummary.prototype.getContext,
          function (fn) {
            var context = fn.apply(
              this,
              Array.prototype.slice.call(arguments, 1)
            );
            context.useExternalInventory = _.isEmpty(getInventoryJson())
              ? false
              : true;
            return context;
          }
        );
      }
      var updateAllLinesModel = function updateAllLinesModel() {
        var selectedLocationName = getCurrentLocation(true);
        var shoppingExperience = LocationsModel.getShoppingExperience();
        if (shoppingExperience == "online") selectedLocationName = "Fedco";
        var lines = LiveOrder.get("lines").models;
        var data = [];
        lines.forEach(function (line) {
          var item = line.get("item");
          var group = item.get("custitemrs_brand");
          var groupId = item.get("itemid");
          var itemRecordType = item.get("itemtype");
          if (
            recordTypesWithInventory.indexOf(itemRecordType.toLowerCase()) != -1
          )
            data.push({
              Group: group,
              GroupIdentifier: groupId,
              selectedLocation: selectedLocationName,
            });
        });
        return data;
      };
      var moduleAdded = false;
      var updateExternalInventory = function updateExternalInventory() {
        var newJson = {};
        var newIntJson = {};
        var itemsMissingStock = [];
        var lines = LiveOrder.get("lines").models;
        var oldMappedInventory = getInventoryJson();
        var currentLocation = getCurrentLocation(true);
        lines.forEach(function (line, index) {
          //Info of the item
          var item = line.getItem();
          var item_id = item.get("internalid");
          var quantity = line.get("quantity");
          var sku = item.get("itemid");

          //Internal stock for current location
          var internalStockField = getInternalStockField();
          var internalStock = item.get(internalStockField) || 0;

          //Missing inventory
          var missingInventory = parseInt(quantity - internalStock, 10) * -1;

          //If no missing inventory, continue
          if (missingInventory >= 0) {
            if (_.has(oldMappedInventory, item_id)) {
              oldMappedInventory = _.omit(oldMappedInventory, item_id);
              setInventoryJson(oldMappedInventory);
            }
            return;
          }

          //Acquire warehouses and remaining missing inventory
          var _mapInventory = mapInventory(missingInventory, sku, "external"),
            mappedInventory = _mapInventory.mappedInventory,
            missingInventory = _mapInventory.missingInventory;
          if (mappedInventory.length) {
            newJson[item_id] = mappedInventory;
          }

          //If there is missing inventory, save item information
          if (missingInventory !== 0) {
            var requiredInternalStock = getInternalStocks(item);
            if (!requiredInternalStock.length) return;
            itemsMissingStock.push({
              sku: sku,
              item_id: item_id,
              selectedLocation: currentLocation,
              quantity: missingInventory,
              askedLocations: JSON.stringify(requiredInternalStock),
            });
          }
        });

        // Set other stores inventory for each item
        if (itemsMissingStock.length) {
          itemsMissingStock[0].externalLocations = JSON.stringify(
            Model.get("externalLocations")
          );
          Model.getInternalInventory(itemsMissingStock).then(function (data) {
            delete data.internalLocations[0].data[0].externalLocations;
            data.internalLocations.forEach(function (itemInfo) {
              var item_id = itemInfo.data[0].item_id;
              var _mapInventory2 = mapInventory(
                  itemInfo.data[0].quantity,
                  itemInfo.data[0].sku,
                  "internal"
                ),
                mappedInventory = _mapInventory2.mappedInventory,
                missingInventory = _mapInventory2.missingInventory;
              newIntJson[item_id] = mappedInventory;
            });
            // Set external inventory
            setInventoryJson(newJson);
            setExternalInventory();

            // Set internal inventory
            setInternalJson(newIntJson);
            setInternalInventory();

            addEstimatedDateModule();

            //trigger address changes
            var change = !LocationsModel.get("finishedExternal");
            LocationsModel.set("finishedExternal", change);
          });
        } else {
          // Set external inventory
          setInventoryJson(newJson);
          setExternalInventory();

          // Set internal inventory
          setInternalJson(newIntJson);
          setInternalInventory();

          addEstimatedDateModule();

          //trigger address changes
          var change = !LocationsModel.get("finishedExternal");
          LocationsModel.set("finishedExternal", change);
        }
      };
      var mapInventory = function mapInventory(missingInventory, sku, type) {
        var inventory;
        var data;
        if (type == "external") {
          if (Model.get("externalLocations")[0]) {
            for (var i = 0; i < Model.get("externalLocations").length; i++) {
              if (
                Model.get("externalLocations")[i] &&
                Model.get("externalLocations")[i].data[0] &&
                Model.get("externalLocations")[i].data[0].GroupIdentifier == sku
              ) {
                var modelData = Model.get("externalLocations")[i];
                inventory = modelData.filteredGroupedLocations;
                data = modelData.data;
                break;
              } else if (!Model.get("externalLocations")[i]) {
                break;
              }
            }
          } else {
            inventory = Model.get("externalLocations").filteredGroupedLocations;
            data = Model.get("externalLocations").data;
          }
        } else if (type == "internal") {
          if (Model.get("internalLocations")[0]) {
            for (var i = 0; i < Model.get("internalLocations").length; i++) {
              if (
                Model.get("internalLocations")[i] &&
                Model.get("internalLocations")[i].data[0] &&
                Model.get("internalLocations")[i].data[0].sku == sku
              ) {
                var modelData = Model.get("internalLocations")[i];
                inventory = modelData.filteredGroupedLocations;
                data = modelData.data;
                break;
              } else if (!Model.get("internalLocations")[i]) {
                break;
              }
            }
          } else {
            inventory = Model.get("internalLocations").filteredGroupedLocations;
            data = Model.get("internalLocations").data;
          }
        }
        if (!inventory)
          return { mappedInventory: [], missingInventory: missingInventory };
        if (!data || !data.length)
          return { mappedInventory: [], missingInventory: missingInventory };
        var missingInventory = missingInventory;
        var mappedWarehouses = [];
        for (var i = 0; i < inventory.length; i++) {
          var obj = inventory[i];
          var newMissingInventory = mapWarehouseList(
            obj.vendors,
            missingInventory,
            mappedWarehouses,
            obj.time,
            obj.time_id,
            data[0],
            type
          );
          missingInventory = newMissingInventory;
          if (missingInventory == 0) break;
        }
        return {
          mappedInventory: mappedWarehouses,
          missingInventory: missingInventory,
        };
      };
      var mapWarehouseList = function mapWarehouseList(
        vendors,
        missingInventory,
        final_arr,
        time,
        time_id,
        data,
        type
      ) {
        if (!_.isArray(vendors)) return [];
        for (var i = 0; i < vendors.length; i++) {
          var vendor = vendors[i];
          var availableStock = vendor.availableStock;

          var usedStock = getUsedAmount({
            stock: availableStock,
            toUse: missingInventory,
          });
          if (usedStock == 0) {
            missingInventory = 0;
            break;
          }
          if (type == "external")
            var warehouseData = {
              warehouseId: vendor.warehouseId,
              rs_id: vendor.rs_id,
              availableStock: vendor.availableStock,
              used_stock: usedStock,
              vendor_name: vendor.name,
              vendor_price: parseInt(vendor.price),
              shipping_eta: {
                text: time,
                value: parseInt(time_id),
              },
              itemData: {
                Group: data.Group,
                GroupIdentifier: data.GroupIdentifier,
                itemClass: data.itemClass,
              },
            };
          else
            var warehouseData = {
              availableStock: vendor.availableStock,
              used_stock: usedStock,
              vendor_name: vendor.name,
              vendor_price: parseInt(vendor.price),
              vendor_location: vendor.vendor,
              shipping_eta: {
                text: time,
                value: parseInt(time_id),
              },
              itemData: {
                Group: data.selectedLocation,
                sku: data.sku,
                // itemClass: data.itemClass
              },
            };

          final_arr.push(warehouseData);
          missingInventory += availableStock;

          if (missingInventory >= 0) {
            missingInventory = 0;
            break;
          }
        }

        return missingInventory;
      };
      var getCurrentLocation = function getCurrentLocation(doMapping) {
        var selectedLocation = LocationsModel.getSelectedLocation();
        var selectedLocationName = selectedLocation
          ? selectedLocation.name
          : "Fedco";

        if (selectedLocationName === "FT. Sask" && doMapping) {
          selectedLocationName = selectedLocationName.replace(
            "Sask",
            "Saskatchewan"
          );
        } else if (selectedLocationName === "Grande Prairie" && !doMapping) {
          selectedLocationName = "Grand Prairie";
        }
        return selectedLocationName;
      };
      var getInternalStockField = function getInternalStockField() {
        var selectedLocationName = getCurrentLocation(false).toUpperCase();
        var internalLocationField = map[selectedLocationName]
          ? map[selectedLocationName].internal
          : "custitem_sdb_fedco_int_ecomm_inv";
        return internalLocationField;
      };
      var map = LocationsModel.getFieldMapper(env);
      var getUsedAmount = function getUsedAmount(options) {
        var stock = options.stock,
          toUse = options.toUse;
        var calculation = stock - (stock + toUse);
        return calculation > stock ? stock : calculation;
      };

      var getInternalStocks = function getInternalStocks(item) {
        var internalStocks = [];
        _.each(map, function (location, locationName) {
          var internalStock = item.get(location.internal) || 0;
          if (internalStock == 0) return;
          if (locationName == getCurrentLocation(false).toUpperCase()) return;
          internalStocks.push({
            Location: locationName,
            fieldId: location.internal,
            internalStock: internalStock,
          });
        });
        return internalStocks; //.sort(function (a, b) { return (a.internalStock - b.internalStock)*-1 });
      };

      var continueDisabled = false;
      Checkout.on("afterShowContent", function () {
        $(document).ready(function () {
          if (continueDisabled)
            $(".order-wizard-step-button-continue").addClass("disabled");
        });
      });

      OrderWizardStep.prototype.getContext = _.wrap(
        OrderWizardStep.prototype.getContext,
        function (fn) {
          var context = fn.apply(this, _.toArray(arguments).slice(1));
          if (continueDisabled) context.disabled = true;
          return context;
        }
      );

      HeaderMiniCart.prototype.getContext = _.wrap(
        HeaderMiniCart.prototype.getContext,
        function (fn) {
          var context = fn.apply(this, _.toArray(arguments).slice(1));
          var cartLines = context.model.get("lines")
            ? context.model.get("lines").models
            : [];
          if (!cartLines) return context;
          var extInventoryJson = getInventoryJson();
          var intInventoryJson = getInternalJson();
          var partialStocks = _.find(cartLines, function (line) {
            var item = line.get("item");
            var internalStockField = getInternalStockField();
            var internalStock = line.getItem().get(internalStockField) || 0;
            var quantity = line.get("quantity");
            var extInventoryData =
              extInventoryJson[item.get("internalid")] || [];
            var intInventoryData =
              intInventoryJson[item.get("internalid")] || [];
            var extInventoryQuantity = !extInventoryData.length
              ? 0
              : extInventoryData.reduce(function (sum, item) {
                  return sum + item.used_stock;
                }, 0);
            var intInventoryQuantity = !intInventoryData.length
              ? 0
              : intInventoryData.reduce(function (sum, item) {
                  return sum + item.used_stock;
                }, 0);
            var inventory =
              internalStock + extInventoryQuantity + intInventoryQuantity;
            var itemRecordType = item.get("itemtype");
            return (
              quantity > inventory &&
              recordTypesWithInventory.indexOf(itemRecordType.toLowerCase()) !==
                -1
            );
          });
          if (partialStocks) {
            context.partialStocks = true;
            $(document).ready(function () {
              $(".order-wizard-step-button-continue").addClass("disabled");
              continueDisabled = true;
            });
          } else {
            $(document).ready(function () {
              $(".order-wizard-step-button-continue").removeClass("disabled");
              continueDisabled = false;
            });
          }
          return context;
        }
      );
      var addEstimatedDateModule = function addEstimatedDateModule() {
        if (moduleAdded) {
          LocationsModel.set("locationChanged", true);
          return;
        }
        Checkout.getCurrentStep().then(function (step) {
          if (moduleAdded) return;
          if (!step || (step.url != "shipping/address" && step.url != "opc"))
            return;

          //this is to check if there is an estimate ship time
          var inventoryData = JSON.parse(
            localStorage.custbody_sdb_store_ext_inv_data || "{}"
          );
          if (inventoryData != {} && Object.keys(inventoryData).length != 0) {
            var hasEstimate = false;
            var inventoryValues = Object.keys(inventoryData).map(function (e) {
              return inventoryData[e];
            });
            for (var j = 0; j < inventoryValues.length; j++) {
              var inventory = inventoryValues[j];
              for (var i = 0; i < inventory.length; i++) {
                var data = inventory[i];
                if (!data.shipping_eta) continue;
                if (data.used_stock == 0) continue;
                //if we reach this point it means there is an estimate for one of the items
                hasEstimate = true;
                break;
              }
            }
          }

          var intData = JSON.parse(
            localStorage.custbody_sdb_store_int_inv_data || "{}"
          );
          if (
            !hasEstimate &&
            intData != {} &&
            Object.keys(intData).length != 0
          ) {
            var intValues = Object.keys(intData).map(function (e) {
              return intData[e];
            });
            for (var j = 0; j < intValues.length; j++) {
              var inventory = intValues[j];
              for (var i = 0; i < inventory.length; i++) {
                var data = inventory[i];
                if (!data.shipping_eta) continue;
                if (data.used_stock == 0) continue;
                //if we reach this point it means there is an estimate for one of the items
                hasEstimate = true;
                break;
              }
            }
          }
          //we only add the module if there is an estimate to show
          if (hasEstimate) {
            Checkout.addModuleToStep({
              step_url: step.url,
              module: {
                id: "EstimatedDeliveryDate",
                index: 50,
                classname: "ExtenralVendor.Inventory.CheckoutModule",
                options: {
                  template: external_vendor_inventory_module_tpl,
                  ExternalInventoryModel: Model,
                  LocationsModel: LocationsModel,
                },
              },
            });
            moduleAdded = true;
          }
        });
      };
    },
  };
});
